import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: ${colors.white};
`;

export const Section = styled.div``;

export const Info = styled.div`
  margin: 20px auto;
  font-size: 14px;
`;

export const Header = styled.div`
  color: ${colors.black};
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 35px;
  text-align: center;
  margin-bottom: 32px;
  margin-top: 26px;
`;

export const RulesList = styled.div`
  color: ${colors.black};
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.3px;
  margin-bottom: 16px;

  li,
  div {
    line-height: 30px;
  }
`;

export const AgreementText = styled.div`
  color: ${colors.black};
  font-size: 16px;
  height: 48px;
  letter-spacing: 0.3px;
  line-height: 24px;
  margin-bottom: 24px;
  width: 512px;
`;
